import axiosInstance from 'helpers/axiosInstance';

export interface Sponsor {
  id: string;
  displayState: string;
  displayName: string;
  displayOrder: number;
  hidePayerId: boolean;
  hideGroupId: boolean;
  hideInsurancePhoneNumber: boolean;
  hideMemberId: boolean;
}

export const LoadingSponsor: Sponsor = {
  id: '',
  displayState: 'disabled',
  displayName: 'Loading...',
  displayOrder: 0,
  hidePayerId: false,
  hideGroupId: false,
  hideInsurancePhoneNumber: false,
  hideMemberId: false,
};

export const OtherSponsor: Sponsor = {
  id: 'Other',
  displayState: '',
  displayName: 'Other',
  displayOrder: 1000,
  hidePayerId: false,
  hideGroupId: false,
  hideInsurancePhoneNumber: false,
  hideMemberId: false,
};

export const getSponsors = () =>
  axiosInstance
    .get<{ sponsors: Sponsor[] }>('/patients/sponsors')
    .then(r => r.data.sponsors ?? (r.data as unknown as Sponsor[]));
